import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import withCompletion from "@pathwright/web/src/modules/completion/graphql/withCompletion"
import "./styles/StepSkipped.css"

const StepSkipped = function (props) {
  const { t, completion } = props

  const skippedBy =
    props.skippedBy ||
    (completion &&
      completion.overridden_by &&
      completion.overridden_by.display_name)

  return (
    <span className="StepSkipped">
      <Pathicon icon="skip" />
      <span> </span>
      {t("step.skipped")}
      {skippedBy ? ` ${t("step.by")} ${skippedBy}` : ""}
    </span>
  )
}

StepSkipped.displayName = "StepSkipped"

export default withCompletion(withTranslate(StepSkipped))
